import { Translation } from '@/hoslog-intl';
import { FormItem, FormLabel, FormMessage } from '.';
import { FormFieldContext } from './context';
import { UseFormFieldProps } from './type';

interface Props extends UseFormFieldProps {
  id: string;
}

const FormField = ({ children, name, label, subLabel, subLabelClassName, link, forceRequired }: Props) => {
  return (
    <FormFieldContext.Provider value={{ name, forceRequired }}>
      <FormItem>
        <div className="flex w-full justify-between">
          {label && (
            <>
              <FormLabel>{label.includes('.') ? <Translation id={label} /> : label}</FormLabel>
            </>
          )}
          {subLabel && (
            <a href={link} target="_blank" className={`ml-auto text-right ${subLabelClassName}`} rel="noreferrer">
              {subLabel}
            </a>
          )}
        </div>
        <div>{children}</div>
        <FormMessage />
      </FormItem>
    </FormFieldContext.Provider>
  );
};

export { FormField };
